export default __webpack_public_path__ + "static/media/model_scanner.a7ea718d.png";